// eslint-disable-next-line import/no-extraneous-dependencies
import { NumDeviceFailedPolicies } from '@kw/rules-service/dist/src/policy/dtos/NumDeviceFailedPolicies.dto';
import { useFetchService } from './fetchService';
import { dateFormatMonthDay } from './dates';

/*
These are some rules-service fetch commands that are used in more than once place, so I pulled them into here so as not to repeat ourselves
 */

export function useNumberDevicesFailedPolicies(range: number, accessToken = '') {
  const path = `/eval/policies/number-devices-failed-policies?range=${range}`;
  const { data, error } = useFetchService<NumDeviceFailedPolicies[]>(path, accessToken);
  return {
    numberDevicesFailedPolicies: dateFormatMonthDay(data) as NumDeviceFailedPolicies[],
    error,
    isLoading: !data && !error,
  };
}
